export default __webpack_public_path__ + "static/media/inspection.ba84f104.svg";